// import Swiper JS
import Swiper, { Pagination, Navigation } from 'swiper';

let init = false,
    swiper;

export default function swiperInit() {
    let swiperEl = document.querySelectorAll('.swiper');
    if(!swiperEl.length) return;

    const options = {
        modules: [ Navigation, Pagination ],
        spaceBetween: 16,
        slidesPerView: 'auto',

        pagination: {
            el: '.swiper-pagination',
            type: 'fraction',
        },

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        }
    };

    if(window.innerWidth < 1024 && !init) {
        swiper = new Swiper('.swiper', options);
        init = true;

        [...swiperEl].forEach( (item) => {
            let container = item.closest('.page-container'),
                prevEl = item.previousElementSibling;

            if(container) {
                container.style.paddingRight = '0';
            }

            while (prevEl) {
                prevEl.style.paddingRight = '20px';
                prevEl = prevEl.previousElementSibling;
            }
        });
    }

    if(window.innerWidth > 1023 && init) {
        swiper.destroy();

        [...swiperEl].forEach( (item) => {
            let container = item.closest('.page-container'),
                prevEl = item.previousElementSibling;

            if(container) {
                container.style.paddingRight = '20px';
            }

            while (prevEl) {
                prevEl.style.paddingRight = '0';
                prevEl = prevEl.previousElementSibling;
            }
        });
        init = false;
    }
}
